<div class="modal-header">
    <h2 class="modal-title fs-5">
        {{ 'savedexport_edit_title' | translate: 'online' : 'export' }}
    </h2>
    <button
        type="button"
        class="btn-close"
        [attr.aria-label]="'reporting_CANCEL' | translate"
        (click)="cancel()"></button>
</div>

<div class="modal-body">
    <app-step-flow
        headingKey="savedexport_edit_title"
        [steps]="slots()"
        [limits]="formService.exportLimits()"
        [statuses]="formService.stepStatuses()" />
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-outline-primary" (click)="cancel()">
        {{ 'reporting_CANCEL' | translate }}
    </button>
    @if (formService.deliversOnSchedule()) {
        <app-export-test-button />
    }
    <app-action-button
        [label]="{key: 'reporting_SAVE', module: 'ngonline'}"
        [busy]="isSaving()"
        [disabled]="isSaving() || formService.saveDisabled()"
        (run)="onSave()" />
</div>
